import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
    name: 'auth',
    initialState: {
      isAuthenticated: Boolean(localStorage.getItem('authToken')),
    },
    reducers: {
      login(state) {
        const token = "Moscow-React";
        localStorage.setItem('authToken', JSON.stringify(token));
        state.isAuthenticated = true;
      },
      logout(state) {
        localStorage.removeItem('authToken');
        state.isAuthenticated = false;
      },
    },
  });
  
  export const { login, logout } = authSlice.actions;
  export default authSlice.reducer;